<template>
  <div class="admin-set">
    <div class="top-warp">
      <el-input v-model="searchInfo.roleName" placeholder="请输入角色名称" prefix-icon="el-icon-search"
                style="margin-right: 15px; width: 300px"></el-input>
      <el-button type="primary" @click="searchClick">搜索</el-button>
    </div>
    <div style="margin-top: 20px">
      <el-button type="primary" @click="openDialog">添加</el-button>
    </div>
    <div>
      <el-table :data="tableData" style="width: 100%; margin-top: 20px;">
        <el-table-column label="角色" prop="role.roleName" width="200"></el-table-column>
        <el-table-column label="成员" prop="userNames" width=""></el-table-column>
        <el-table-column label="操作" prop="date" width="200">
          <template v-slot="{row}">
            <el-button size="mini" @click="editRole(row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="delAdminItem(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination :current-page="searchInfo.pageNum" :page-size="searchInfo.pageSize" :page-sizes="[5, 10, 15, 20]"
                   :total="total" layout="total, sizes, prev, pager, next, jumper" style="margin-top: 20px"
                   @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="dialogVisible" center width="660px">
      <el-form ref="addFromRef" :model="addFrom" :rules="addFromRules" label-width="90px">
        <el-form-item label="角色名称 : " prop="roleName">
          <el-input v-model="addFrom.roleName" placeholder="请输入角色名称" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item v-if="dialogVisible" label="角色权限 : " prop="privilegeIdList">
          <el-tree ref="tree" :data="selectOptions" :default-checked-keys="addFrom.privilegeIdList"
                   :props="defaultProps" check-strictly default-expand-all node-key="id" show-checkbox
                   @check="check">
          </el-tree>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="isAdd" type="primary" @click="confirmClick(1)">确 定</el-button>
        <el-button v-else type="primary" @click="confirmClick(2)">修 改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "backPrivilegeManage",
  data() {
    return {
      searchInfo: {
        roleName: '',
        pageSize: 10,
        pageNum: 1,
      },
      total: 10,
      tableData: [],
      dialogVisible: false,
      addFrom: {
        roleId: 1,
        // 角色名称
        roleName: "",
        // 权限
        privilegeIdList: []
      },
      selectOptions: [],
      dialogTitle: '',
      isAdd: true,
      isDisabled: false,
      addFromRules: {
        roleName: [
          {required: true, message: '请输入角色名称', trigger: 'blur'}
        ],
        privilegeIdList: [
          {required: true, message: '  '}
        ]
      },
      defaultProps: {
        children: 'childPrivilege',
        label: 'privilegeName'
      }
    }
  },
  created() {
    this.getRoleList()
  },
  methods: {
    check(data) {
      let current = this.$refs.tree.getNode(data.id)
      if (data.parentId > 0) {
        let parent = current.parent
        if (!parent.childNodes.filter(item => item.checked).length && current.level !== 3) {
          this.$refs.tree.setChecked(parent, false)
        }
        if (parent.childNodes.filter(item => item.checked).length === parent.childNodes.length) {
          this.$refs.tree.setChecked(parent, true)
        }
        if (parent.childNodes.filter(item => item.checked).length && !parent.checked) {
          this.$refs.tree.setChecked(parent, true, false)
          this.$refs.tree.setChecked(parent.parent, true, false)
        }
      }
      if (current.childNodes.length) {
        data.childPrivilege.forEach(child => {
          this.$refs.tree.setChecked(child.id, current.checked);
          child.childPrivilege.forEach(s => {
            this.$refs.tree.setChecked(s.id, current.checked);
          })
        });
      }
    },
    searchClick() {
      this.getRoleList()
    },
    getAllPrivilege() {
      this.addFrom = {
        roleId: 1,
        // 角色名称
        roleName: "",
        // 权限
        privilegeIdList: []
      }
      if (this.selectOptions.length) return
      this.$request.allPrivilege().then(({status, data}) => {
        if (status === 200) {
          this.selectOptions = data
        }
      }).catch(() => {
      })
    },
    openDialog() {
      this.getAllPrivilege()
      this.dialogTitle = '添加'
      this.dialogVisible = true
      this.isDisabled = false
      this.isAdd = true
    },
    confirmClick(type) {
      if (!this.addFrom.roleName) {
        this.$message.warning('请输入角色名称')
        return;
      }
      let tree = this.$refs.tree
      this.addFrom.privilegeIdList = [].concat(tree.getCheckedKeys(), tree.getHalfCheckedKeys())
      if (!this.addFrom.privilegeIdList.length) {
        this.$message.warning('请选择角色权限')
        return
      }
      if (type == 1) {
        this.addRole()
      } else if (type == 2) {
        this.actRole()
      }
      this.dialogVisible = false
    },
    // 编辑权限
    editRole({role, rolePrivilegeVos}) {
      let privilegeIdList = []
      rolePrivilegeVos.forEach(f => {
        if (f['hasAuthority']) {
          privilegeIdList.push(f.id)
        }
        f['children'].forEach(s => {
          if (s['hasAuthority']) {
            privilegeIdList.push(s.id)
          }
          s['children'].forEach(t => {
            if (t['hasAuthority']) {
              privilegeIdList.push(t.id)
            }
          })
        })
      })
      this.getAllPrivilege()
      this.dialogTitle = '编辑'
      this.dialogVisible = true
      this.isDisabled = true
      this.isAdd = false
      this.addFrom = {
        roleId: role.id,
        roleName: role.roleName,
        privilegeIdList
      }
    },
    // 删除
    delAdminItem({role}) {
      this.$confirm('此操作将删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRole(role.id)
      }).catch(() => {
      });
    },
    handleSizeChange(val) {
      this.searchInfo.pageSize = val
      this.getRoleList()
    },
    handleCurrentChange(val) {
      this.searchInfo.pageNum = val
      this.getRoleList()
    },
    // 获取列表
    async getRoleList() {
      let res = await this.$request.privilegeList(this.searchInfo)
      if (res.status == 200) {
        this.tableData = res.data.list
        this.total = res.data.total
      }
    },
    async addRole() {
      let res = await this.$request.addPrivilege(this.addFrom)
      if (res.status == 200) {
        this.addFrom.privilegeIdList = []
        this.addFrom.roleName = ''
        this.$message.success('添加成功')
        await this.getRoleList()
      } else {
        this.$message.error(res.message)
      }
    },
    async actRole() {
      let res = await this.$request.editPrivilege(this.addFrom)
      if (res.status == 200) {
        this.$message.success('修改成功')
        await this.getRoleList()
      } else {
        this.$message.error(res.message)
      }
    },
    async deleteRole(id) {
      let res = await this.$request.delPrivilege({id})
      if (res.status == 200) {
        this.$message.success('删除成功')
        await this.getRoleList()
      } else {
        this.$message.error(res.message)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.admin-set {
  width: 100%;
  padding: 20px;
}

/deep/ .el-input {
  width: 100%;
}
</style>